import { useContext, useRef } from 'react';

import PageContext from '../../Context/PageContext';
import SketchColor from './SketchColor';

const ShapePicker = () => {
  const { objItems, selectedItem } = useContext(PageContext);

  const item = objItems.find(item => item.id === selectedItem.id);

  const targetRef = useRef<HTMLInputElement>(null);

  var defaultValue = 10;

  const handleChange = (e: any) => {

    var value = Number(e.target.value);
    if (selectedItem != null) {
      selectedItem.querySelector('div').style.borderWidth = value + 'px';
      item.style['border-width'] = value + 'px';
    }
  }

  /* To set default value or target value if exists*/
  if (selectedItem != null) {

    var borderValue = item != null ? item.style["border-width"] : defaultValue;

    if (typeof borderValue === 'string') {
      borderValue = borderValue.replace("px", "");
    }

    if (targetRef.current != null) targetRef.current.value = borderValue;
    else defaultValue = borderValue
  }



  return (
    <div className="text-picker">
      <SketchColor key={item.style.color} elem={'selectedItem'} color={item != null ? item.style.color : 'white'} />

      {item.class.includes('bordure') && <SketchColor key={item.style['border-color']} elem={'selectedItem-border'} color={item != null ? item.style['border-color'] : 'white'} />}
      {item.class.includes('bordure') && <input type="number" id="shape-border-width" ref={targetRef} onChange={handleChange} defaultValue={defaultValue} />}
    </div>
  );

};

export default ShapePicker;